import React, { useState } from "react";
import ModifyBlockModal from "./ModifyBlockModal";
import LinkBlockModal from "./LinkBlockModal";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function BlockDetailsModal({ isOpen, onClose, blockId }) {
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);

  if (!isOpen || !blockId) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative bg-white rounded-sm shadow-md w-full max-w-lg p-4">
        {/* Close Button */}
        <button
          onClick={() => {
            if (!showModifyModal && !showLinkModal) {
              onClose(); // Prevent closing if a sub-modal is open
            }
          }}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition-colors">
          <XMarkIcon className="h-5 w-5" />
        </button>

        {/* Modal Title */}
        <h2 className="text-base font-semibold text-gray-900">Block Actions</h2>
        <p className="text-xs text-gray-600 mt-1">
          Choose an action for this block.
        </p>

        {/* Buttons */}
        <div className="mt-4 flex flex-col space-y-2">
          <button
            onClick={() => setShowModifyModal(true)}
            className="w-full rounded-sm bg-indigo-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-indigo-500 transition-colors shadow-sm">
            Modify Block
          </button>
          <button
            onClick={() => setShowLinkModal(true)}
            className="w-full rounded-sm bg-indigo-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-indigo-500 transition-colors shadow-sm">
            Link/Unlink Block
          </button>
        </div>
      </div>

      {/* Modals */}
      {showModifyModal && (
        <ModifyBlockModal
          isOpen={showModifyModal}
          onClose={() => setShowModifyModal(false)}
          blockId={blockId}
        />
      )}

      {showLinkModal && (
        <LinkBlockModal
          isOpen={showLinkModal}
          onClose={() => setShowLinkModal(false)}
          blockId={blockId}
        />
      )}
    </div>
  );
}
